import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  useTheme,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  alpha,
  styled,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import TerminalIcon from "@mui/icons-material/Terminal"; // Ícone com tema tech
import Brightness4Icon from "@mui/icons-material/Brightness4"; // Ícone para tema dark

// Botão estilizado com efeito neon
const NeonButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.light,
  border: `1px solid ${alpha(theme.palette.primary.light, 0.5)}`,
  padding: theme.spacing(1, 3),
  borderRadius: theme.shape.borderRadius,
  transition: "all 0.3s ease",
  textShadow: `0 0 5px ${alpha(theme.palette.primary.light, 0.5)}`,
  "&:hover": {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 15px ${alpha(theme.palette.primary.main, 0.7)}`,
  },
}));

export const Navbar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const navItems = ["Cobertura", "Planos", "Tecnologia", "Contato"];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const logo = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <TerminalIcon sx={{ color: theme.palette.primary.light, fontSize: 28 }} />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          color: theme.palette.text.primary,
          letterSpacing: "0.05em",
        }}
      >
        PLANOS_DEV
      </Typography>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      elevation={0}
      // Estilos já definidos no tema geral para AppBar com backdropFilter
    >
      <Container maxWidth="lg">
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            height: 60,
          }}
        >
          {logo}

          {!isMobile && (
            <Box sx={{ mx: 2 }}>
              {navItems.map((item) => (
                <Button
                  key={item}
                  sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    mx: 1.5,
                    fontSize: "0.85rem",
                    letterSpacing: "0.03em",
                    "&:hover": {
                      color: theme.palette.primary.light,
                      backgroundColor: "transparent",
                    },
                  }}
                  href={`#${item.toLowerCase()}`}
                >
                  {item}
                </Button>
              ))}
            </Box>
          )}

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Ícone opcional de tema */}
            <IconButton sx={{ color: theme.palette.text.secondary }}>
              <Brightness4Icon fontSize="small" />
            </IconButton>

            {!isMobile && (
              <NeonButton href="#formulario">Fale Conosco</NeonButton>
            )}

            {isMobile && (
              <IconButton
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerToggle}
                sx={{ color: theme.palette.primary.light }}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </Container>

      {/* Menu Mobile */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            width: "80%",
            maxWidth: "300px",
            p: 2,
            backgroundColor: theme.palette.background.paper, // Usar cor de fundo do paper
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          {logo}
          <IconButton
            onClick={handleDrawerToggle}
            sx={{ color: theme.palette.text.secondary }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <List sx={{ mb: 3 }}>
          {navItems.map((item) => (
            <ListItem disablePadding key={item} sx={{ mb: 1 }}>
              <ListItemButton
                onClick={handleDrawerToggle}
                component="a"
                href={`#${item.toLowerCase()}`}
                sx={{
                  borderRadius: 1,
                  py: 1.2,
                  "&:hover": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                  },
                }}
              >
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <NeonButton href="#formulario" fullWidth>
          Fale Conosco
        </NeonButton>
      </Drawer>
    </AppBar>
  );
};
